export const queryKeys = {
    legacyMessages: (userId: string) => ["legacyMessages", userId.trim()] as const,

    effectivePlatformLimits: (userId: string) =>
        ["effectivePlatformLimits", userId.trim()] as const,

    userSettings: (userId: string) => ["userSettings", userId.trim()] as const,

    messageDetail: (messageId: string) =>
        ["messageDetail", messageId.trim()] as const,

    recipients: (userId: string) => ["recipients", userId.trim()] as const,

    attachments: (userId: string) => ["attachments", userId.trim()] as const,

    deliveredMessages: (recipientEmail: string) =>
        ["deliveredMessages", recipientEmail.trim().toLowerCase()] as const,

    deliveredMessagesBySender: (userId: string) =>
        ["deliveredMessagesBySender", userId.trim()] as const,

    deliveredMessageAttachments: (deliveredMessageId: string) =>
        ["deliveredMessageAttachments", deliveredMessageId.trim()] as const,

    plan: (userId: string) => ["plan", userId.trim()] as const,

    legalAcceptance: (userId: string) => ["legalAcceptance", userId.trim()] as const,
};
